import { render, staticRenderFns } from "./Illustratie.vue?vue&type=template&id=2764a641&scoped=true&"
import script from "./Illustratie.vue?vue&type=script&lang=js&"
export * from "./Illustratie.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Illustratie.vue?vue&type=style&index=0&id=2764a641&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2764a641",
  null
  ,true
)

export default component.exports